// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconKeys_loader__Jn0SS","strokeMarketplaceColor":"IconKeys_strokeMarketplaceColor__2wv_O"};